"use strict";

var dashboardVersion = require('./../../_js-common-modules').dashboardVersion;

// Dashboard Version Selectior (for Demo purposes only)
(function() {
    var DASHBOARD_SERVICE_URL = "http://dashboards.webkom.co:8000";

    var dashboardFetcher = dashboardVersion.getDashboardFetcher(DASHBOARD_SERVICE_URL);
    var formatDate = function(inputDate) {
        return (new Date(inputDate)).toLocaleDateString("en-US", {
            weekday: "short",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit"
        });
    }

    Dashboard = Object.assign({ }, window.Dashboard || { }, {
        VersionSelector: {
            initVersionWidget: function(label, name, $container, callback) {
                var $dateElement = $container.find("[data-version=date]");
                var $versionElement = $container.find("[data-version=number]");
                var $labelElement = $container.find("[data-version=label]");
                
                dashboardVersion.getCurrentVersion(
                    dashboardFetcher,
                    label,
                    name
                ).then(function(dashboardDef) {
                    $dateElement.text(formatDate(dashboardDef.date));
                    $versionElement.text(dashboardDef.version);
                    $labelElement.text(dashboardDef.label);

                    if (callback) {
                        callback(dashboardDef, $container);
                    }
                });
            },
            initVersionsDropdown: function(name, $appendContainer, itemMarkup, itemCallback) {
                dashboardVersion.getVersions(dashboardFetcher)
                    .then(function (dashboardVersions) {
                        dashboardVersions
                            .filter(function(def) {
                                return def.dashboardName === name;
                            })
                            .forEach(function(dashboardDef) {
                                var $newItem = $(itemMarkup);
                                
                                $newItem.find("[data-version=date]").text(formatDate(dashboardDef.date));
                                $newItem.find("[data-version=number]").text(dashboardDef.version);
                                $newItem.find("[data-version=label]").text(dashboardDef.label);
                                $newItem.find("[data-version=link]").add($newItem).prop("href", dashboardDef.demoUrl);

                                if (itemCallback) {
                                    itemCallback(dashboardDef, $newItem);
                                }

                                $appendContainer.append($newItem);
                            });
                    });
            }
        }
    });
})();
